import SecureInput from './SecureInput';

export default SecureInput;
